const arr = [
    {
        id: 1,
        pos: "transform:rotateX(2105deg) rotateY(3015deg)"
    },
    {
        id: 2,
        pos: "transform:rotateX(2180deg) rotateY(3405deg)"
    },
    {
        id: 3,
        pos: "transform:rotateX(2275deg) rotateY(3365deg)"
    },
    {
        id: 4,
        pos: "transform:rotateX(2366deg) rotateY(3435deg)"
    },
    {
        id: 5,
        pos: "transform:rotateX(2535deg) rotateY(3530deg)"
    },
    {
        id: 6,
        pos: "transform:rotateX(2718deg) rotateY(3535deg)"
    }
];

export default arr;